import SidePanContext from '@Contexts/SidePan';
import { useContext } from 'react';

const useSidePan = () => useContext(SidePanContext);

export default useSidePan;
